import React from 'react';
import './App.css';
import Input from './components/Input.js'
import Shape from './components/Shape.js'
import Count from './components/Count.js'
import Flag from './components/Flag.js'
import Result from './components/Result.js'
import Start from './components/Start.js'
import axios from 'axios';

const REACT_APP_API_URL = process.env.NODE_ENV === 'development' ? "https://geolearn-backend.onrender.com": "https://geolearn-backend.onrender.com" //for development, add http://localhost:8000 here
const COUNTRIES_URL = REACT_APP_API_URL + "/hello/"

function shuffle(array) {
  let currentIndex = array.length,  randomIndex;

  while (currentIndex !== 0) {

    randomIndex = Math.floor(Math.random() * currentIndex);
    currentIndex--;

    [array[currentIndex], array[randomIndex]] = [
      array[randomIndex], array[currentIndex]];
  }

  return array;
}

class App extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      country: "",
      subregion: "",
      flagsrc: "",
      holderArr: "",
      unansweredArr: [],
      correctArr: [],
      unansweredIndex: 0,
      correctAnswers: 0,
      mode: "start",
    };
    this.prevQuestionSkip = this.prevQuestionSkip.bind(this);
    this.nextQuestionSkip = this.nextQuestionSkip.bind(this);
    this.nextQuestionCorrect = this.nextQuestionCorrect.bind(this);
    this.gameStart = this.gameStart.bind(this);
    this.finish = this.finish.bind(this);
  }

  componentDidMount() {
    console.log(COUNTRIES_URL)
    axios.get(COUNTRIES_URL)
    .then(response => {
      this.setState({
        holderArr: shuffle(Object.entries(response.data)),
      })
    });
  }; 

  updateQuestion() {
    this.setState(previousState => ( {
      country: previousState.unansweredArr[previousState.unansweredIndex][0],
      subregion: previousState.unansweredArr[previousState.unansweredIndex][1]['subregion'],
      flagsrc: previousState.unansweredArr[previousState.unansweredIndex][1]['flag_image'],
    }))
  }

  prevQuestionSkip() {
    if (this.state.unansweredIndex <= 0) {
      this.setState(previousState => ({
        unansweredIndex: previousState.unansweredArr.length - 1,
      }))
    } else {
      this.setState(previousState => ({
        unansweredIndex: previousState.unansweredIndex - 1,
      }))
    }
    this.updateQuestion();
  }

  nextQuestionSkip = () => {
    if (this.state.unansweredIndex >= this.state.unansweredArr.length - 1) {
      this.setState({
        unansweredIndex: 0,
      })
    } else {
      this.setState(previousState => ({
        unansweredIndex: previousState.unansweredIndex + 1,
      }))
    }
    this.updateQuestion();
  }

  nextQuestionCorrect() { 
    var unansweredArrTemp = [...this.state.unansweredArr];
    if (unansweredArrTemp.length === 0){
      this.setState({
        mode: "finished",
      })
    }
    var toAddtoCorrectArr = unansweredArrTemp.splice(this.state.unansweredIndex, 1);
    var correctArrTemp = [...this.state.correctArr];
    correctArrTemp.push(toAddtoCorrectArr);

    this.setState(previousState => ({
      correctAnswers: previousState.correctAnswers + 1,
      unansweredArr: unansweredArrTemp,
      correctArr: correctArrTemp,
    }))
    if (this.state.unansweredIndex === this.state.unansweredArr.length - 1) {
      this.setState(previousState => ({
        unansweredIndex: previousState.unansweredIndex - 1,
      }))
    }
    this.updateQuestion()
  }   

  gameStart() {
    this.setState({
      mode: "quiz",
      country: this.state.holderArr[0][0],
      subregion: this.state.holderArr[0][1]['subregion'],
      flagsrc: this.state.holderArr[0][1]['flag_image'],
      unansweredArr: this.state.holderArr,
    })
  }

  finish() {
    this.setState({
      mode: "finished",
    })
  }


  render(){
    if (this.state.mode === "finished") {
      return (
        <div className="App" class="overflow-auto bg-sky-200">
          <div className='titleBanner'>
            <h1 class="text-3xl font-bold sm:text-3xl text-center">🌎 GeoLearn</h1>
            <Count correctAnswers={this.state.correctAnswers}></Count>
          </div>
            <Result correctArr={this.state.correctArr} unansweredArr={this.state.unansweredArr}></Result>
        </div>
      );
    }
    else if (this.state.mode === "start") {
      return (
        <div className="App">
        <div className='titleBanner'>
          <h1 class="text-3xl font-bold sm:text-3xl">🌎 GeoLearn</h1>
        </div>
        <div className='startButton'>
          <Start gameStart={this.gameStart}></Start>
        </div>
      </div>
      );
    }
    return (
      <div className="App">
        <div className='titleBanner'>
          <h1 class="text-3xl font-bold sm:text-3xl">🌎 GeoLearn</h1>
          <Count correctAnswers={this.state.correctAnswers}></Count>
        </div>
        
        <div className='bodyGame'>
          <div className="Question">
            <Flag country={this.state.country} flag={this.state.flagsrc}></Flag>
            <Shape country={this.state.country} subregion={this.state.subregion}></Shape>
          </div>
          <Input country={this.state.country} index={this.state.unansweredIndex} nextQuestionSkip={this.nextQuestionSkip} 
            correctAnswerFunc={this.nextQuestionCorrect} prevQuestionSkip={this.prevQuestionSkip} finish={this.finish} ></Input>
        </div>

      </div>
    );
  }
}

export default App;
